import { IPricingTableCurrencySettings } from '@lib-shared/editor/types';

export class PricingTableHelper {
  static currencyFormat(value: string, currencySettings: IPricingTableCurrencySettings): string {
    if (!currencySettings || !currencySettings?.formatOptions?.currency) {
      return '';
    }
    const { locale, formatOptions } = currencySettings;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      ...formatOptions,
    }).format(Number(value));
  }
}
